module.exports = __webpack_public_path__ + "media/images/support/geolocation/geolocation-chrome-permission-2-9624af5fce50ab36684d52984fa6c84d.png";